import { render, staticRenderFns } from "./bjharticle.vue?vue&type=template&id=5391a32b&scoped=true&"
import script from "./bjharticle.vue?vue&type=script&lang=js&"
export * from "./bjharticle.vue?vue&type=script&lang=js&"
import style0 from "./bjharticle.vue?vue&type=style&index=0&id=5391a32b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391a32b",
  null
  
)

export default component.exports